import LearningConfigAPI from '@/apis/business/teacher/learning-config-api.js'
import { HttpStatusCode } from '@/common/constant'

export default {
  namespaced: true,

  state: {
    learningConfigs: [],
    learningConfig: {},
    platformOnlineMeetingActive: null
  },

  getters: {
    getLearningConfig (state) {
      return state.learningConfig
    }
  },

  mutations: {
    // setTags (state, tags) {
    //   state.tags = tags
    // },

    // setOrganizations (state, organizations) {
    //   state.organizations = organizations
    // }
    setLearningConfigs (state, data) {
      state.learningConfigs = data
    },

    /**
     * set data cho phòng học
     * @param {*} state
     * @param {*} learningConfig
     */
    setLearningConfig (state, learningConfig) {
      state.learningConfig = learningConfig
    },

    /**
     * Thêm data cho danh sách phòng học
     * @param {*} state
     * @param {*} learningConfig
     */
    addLearningConfig (state, learningConfig) {
      state.learningConfigs.push(learningConfig)
    },

    /**
     * Sửa thông tin phòng học
     * @param {*} state
     * @param {*} learningConfig
     */
    updateLearningConfig (state, learningConfig) {
      const index = state.learningConfigs.findIndex((item) => {
        return item.Id === learningConfig.Id
      })

      state.learningConfigs[index] = learningConfig
    },

    /**
     * Xóa 1 bản ghi trong danh sách phòng
     * @param {*} state
     * @param {*} id
     */
    removeLeaningConfig (state, id) {
      const index = state.learningConfigs.findIndex((item) => {
        return item.Id === id
      })

      state.learningConfigs.splice(index, 1)
    },

    /**
     * @description set thông tin đăng nhập tài khoản phòng học (loại nào)
     * @author VDDung1
     * @param {*} state
     * @param {*} type
     */
    setPlatformOnlineMeetingActive (state, type) {
      state.platformOnlineMeetingActive = type
    }
  },

  actions: {
    /**
     * lấy ra config MSTeam
     * @param {*} context
     * @returns
     */
    async getMsTeamConfig (context) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.getAsync('microsoft-team')
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * update Config MSTEAM
     * @param {*} context
     * @param {*} param
     * @returns
     */
    async updateMsTeamConfig (context, param) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.postAsync('microsoft-team', param)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              resolve(res)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Lấy 1 learning config
     * @author NTQuy
     */
    async getLearningConfig (context, learningConfigID) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.getAsync(learningConfigID)
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setLearningConfig', res?.Data)
              resolve(true)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * lấy ra tất cả phòng học theo User
     * @param {*} context
     * @returns
     * @author VDDung1
     */
    async getLearningConfigs (context) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.getAsync('learning-config')
          .then((res) => {
            if (res.IsSuccess && res.Code === HttpStatusCode.OK) {
              context.commit('setLearningConfigs', res?.Data)
              resolve(res?.Data)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Thêm mới một phòng học trực tuyến
     * @param {*} context
     * @param {*} param
     * @returns
     * @author VDDung1
     */
    addLearningConfig (context, param) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.addLearningConfig(param)
          .then((res) => {
            param.Id = res?.Data
            context.commit('addLearningConfig', param)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description update phòng học
     * @author NTQuy
     * @param {*} context
     * @param {*} learningConfig
     * @returns
     */
    updateLearningConfig (context, learningConfig) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.updateLearningConfig(
          learningConfig.Id,
          learningConfig
        )
          .then((res) => {
            context.commit('updateLearningConfig', learningConfig)
            resolve(true)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @description Xóa 1 phòng học
     * @author NTQuy
     * @param {*} context
     * @param {*} id
     * @returns
     */
    deleteLearningConfig (context, id) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.deleteLearningConfig(id)
          .then(context.commit('removeLeaningConfig', id), resolve(true))
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Đăng nhập với Zoom-Meetings
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     * @returns
     */
    createZoomMeetingConfig (context, authorizationCode) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.postAsync('zoom-meetings', authorizationCode)
          .then((res) => {
            if (res && res.Data) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Tạo lịch học với Zoom-Meetings
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     * @returns
     */
    createEventZoomMeetings (context, param) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.postAsync('zoom-meetings-event', param)
          .then((res) => {
            if (res && res.IsSuccess && res.Data.Data) {
              resolve(res.Data.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Xóa dữ liệu 1 lịch học trên Zoom
     * @author VDDung1
     * @param {*} context
     * @param {*} meetingId
     * @returns
     */
    deleteEventZoomMeeting (context, meetingId) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.deleteAsync(`zoom-meetings-event?meetingId=${meetingId}`)
          .then((res) => {
            if (res && res.IsSuccess) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy ra đường dẫn đăng nhập google meet
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     * @returns
     */
    getUrlLoginGoogleMeet (context) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.getAsync('google-meet')
          .then((res) => {
            if (res && res.IsSuccess && res.Data) {
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Đăng nhập với Google Meet
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     * @returns
     */
    createGoogleMeetConfig (context, authorCode) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.postAsync('google-meet', authorCode)
          .then((res) => {
            if (res && res.Data) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Tạo lịch học với Google-Meet
     * @author VDDung1
     * @param {*} context
     * @param {*} param
     * @returns
     */
    createEventGoogleMeet (context, param) {
      return new Promise((resolve, reject) => {
        LearningConfigAPI.postAsync('google-meet-event', param)
          .then((res) => {
            if (res && res.IsSuccess && res.Data) {
              resolve(res.Data)
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
